import { useParams } from "react-router-dom";
import { useRestClientContext } from "../contexts/RestClientContext";
import { PropsWithChildren, useEffect, useState } from "react";
import { Group } from "../types/types";
import { useTeamContext } from "../contexts/TeamContext";
import Page from "./Page";
import { Header } from "semantic-ui-react";
import Preloader from "../components/UI/Preloader/Preloader";

interface TablePageProps extends PropsWithChildren {
	title: string;
}

export default function TablePage({ title, children }: TablePageProps) {
	const client = useRestClientContext();
	const team = useTeamContext();
	const route = useParams();
	const isViewingGroup = "group_id" in route;

	const [group, setGroup] = useState<Group>();
	const [isLoadingGroup, setIsLoadingGroup] = useState(isViewingGroup);

	// NB: Group?
	useEffect(() => {
		if (!isViewingGroup) {
			setGroup(undefined);
			return;
		}

		client
			.fetchGroup(team.id, Number(route.group_id))
			.then((response) => response.json())
			.then((json) => {
				setGroup(json);
				setIsLoadingGroup(false);
			});
	}, [client, isViewingGroup, route.group_id, team.id]);

	if (group) title += " - " + group.name;
	else if (isLoadingGroup) return <Preloader />;

	return (
		<Page className="table">
			<Header as="h1">{title}</Header>
			{children}
		</Page>
	);
}
